/*
 * Priority badges and the group headers of the default (priority) sort. The
 * grouping mirrors goserver's priority ORDER BY: open instant/P0 rows first,
 * then P1, then P2.
 */

import { is_instant_live } from './instant';

export type Priority = 'P0' | 'P1' | 'P2';
export type PriorityGroup = 'instant_p0' | 'p1' | 'p2';

export interface PriorityItem {
  status?: string;
  is_instant?: boolean;
  priority?: string | null;
}

export interface PriorityMeta {
  label: string;
  bg: string;
  fg: string;
  title: string;
}

export const PRIORITY_META: Record<Priority, PriorityMeta> = {
  P0: {
    label: 'P0',
    bg: 'var(--state-error-bg)',
    fg: 'var(--state-error-text)',
    title: 'P0 — act now'
  },
  P1: {
    label: 'P1',
    bg: 'var(--state-warning-bg)',
    fg: 'var(--state-warning-text)',
    title: 'P1 — today'
  },
  P2: {
    label: 'P2',
    bg: 'var(--surface-sunken)',
    fg: 'var(--text-secondary)',
    title: 'P2 — follow-up'
  }
};

// Rows predating tiering carry no priority; the server defaults them to P2.
export const priority_of = (item: PriorityItem | null | undefined): Priority => {
  const p = item?.priority;
  return p === 'P0' || p === 'P1' || p === 'P2' ? p : 'P2';
};

export const priority_group = (item: PriorityItem | null | undefined): PriorityGroup => {
  if (is_instant_live(item)) return 'instant_p0';
  const p = priority_of(item);
  if (p === 'P0') return 'instant_p0';
  return p === 'P1' ? 'p1' : 'p2';
};

export const GROUP_LABELS: Record<PriorityGroup, string> = {
  instant_p0: 'INSTANT / P0 — OLDEST FIRST',
  p1: 'P1 — OVERDUE FIRST',
  p2: 'P2 — OVERDUE FIRST'
};

export interface GroupBreak {
  index: number;
  label: string;
}

// One header before the first row of every run of the same group.
export const group_breaks = (
  rows: Array<PriorityItem | null | undefined> | null | undefined
): GroupBreak[] => {
  const out: GroupBreak[] = [];
  let prev: PriorityGroup | null = null;
  (rows || []).forEach((row, index) => {
    const g = priority_group(row);
    if (g !== prev) out.push({ index, label: GROUP_LABELS[g] });
    prev = g;
  });
  return out;
};
